<template>
  <div class="modul">
    <div class="modul-top">
      <div class="caidan-img">
        <img src="../../../assets/image/caidan.png"
             alt="菜单">
      </div>
      <div class="caidan-title">
        检测报告
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeqingBridgeAndTunnelJiancebaogao',

  data () {
    return {

    };
  },

  mounted () {

  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
</style>